import { GraphQLObjectType } from 'graphql';

// These are mutation implementations that mutate/resolve data with realm db only
import AddPerformance from './addPerformance.gql';
import AddQuestionSubmission from './addQuestionSubmission.gql';
import UpdateBlockPerformance from './updateBlockPerformance.gql';
import PerQuestionSubmission from './perQuestionSubmission.gql';
import SetProgressMeasureForLearningCard from './setProgressMeasureForLearningCard.gql';
import UnSubmit from './unSubmit.gql';
import ResubmitAssignment from './reSubmitAssignment.gql';
import UpdateScorm from './updateScorm.gql';

module.exports = new GraphQLObjectType({
  name: 'Mutation',
  fields: () => ({
    addPerformance: AddPerformance,
    addQuestionSubmission: AddQuestionSubmission,
    updateBlockPerformance: UpdateBlockPerformance,
    perQuestionSubmission: PerQuestionSubmission,
    setProgressMeasureForLearningCard: SetProgressMeasureForLearningCard,
    unSubmit: UnSubmit,
    resubmitAssignment: ResubmitAssignment,
    updateScorm: UpdateScorm
  })
});
